import api, { apiSetup } from '../api';

apiSetup();

export class CodesService {
  BASE_URL = '/actions/codes';

  get() {
    return api.get(this.BASE_URL);
  }
}
